import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteSpesificationSaga,
  getSpesificationDetailsSaga,
  getSpesificationListSaga,
} from "src/store/web-spesifications/saga";
import {
  SpesificationDetailDto,
  SpesificationDto,
} from "src/store/web-spesifications/type";
import SpesificationsCreateForm from "./create";
import SpesificationsEditForm from "./edit";
const SpesificationsPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState<SpesificationDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<SpesificationDetailDto>();
  const columns = [
    {
      text: t("Spesifications.Sector"),
      dataField: "SectorName",
    },
    {
      text: t("Spesifications.Title"),
      dataField: "Title",
    },
    {
      text: t("Spesifications.Icon"),
      dataField: "Icon",
      formatter: (cellContent: string) => <i className={cellContent}></i>,
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Spesifications.PageTitle")}
        metaTag={t("Spesifications.MetaTag")}
        gridProps={{
          addTitle: t("Spesifications.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getSpesificationListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getSpesificationDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: SpesificationDto) =>
              t("Spesifications.DeleteQA", {
                name: data.Title,
              }),
            action: deleteSpesificationSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <SpesificationsCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getSpesificationListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <SpesificationsEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getSpesificationListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default SpesificationsPage;
